export default "__VITE_ASSET__CqBXUG9H__"